import { SymmetricHorizontalMergeStrategy } from './SymmetricHorizontalMergeStrategy';

export type { MergeStrategy } from './types';

export const DEFAULT_MERGE_STRATEGY = new SymmetricHorizontalMergeStrategy();
